export default "https://assets.egbcdn.net/assets/packs/_/images/seed-0dd24c29ab619ab608ede9d3f6b7c6d4.svg";